import { Injectable, Injector } from '@angular/core';
import { ApModalResult, ApModalResultSuccess, ApModalService } from 'webcommon/core-ui';
import { ViewOptionModalComponent } from './view-option-modal.component';
import { ApFindControlModalService, FindControlMode } from 'webcommon/find-control';
import { FindControlRepository, UIFilterRepository } from 'webcommon/webapi';
import { ApBaseClass, IColumnPk, PatientNavService, PatientTabContext, ViewOptionDto, ViewOptionResponse } from 'webcommon/shared';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ViewOptionModalService extends ApBaseClass {
    public defaultFilterOptionId: string | null = null;
    private patientId: string;

    constructor(
        private apModalService: ApModalService,
        private apFindControlModalService: ApFindControlModalService,
        private elementInjector: Injector,
        private uiFilterRepository: UIFilterRepository,
        private patientNavService: PatientNavService,
        private findControlRepo: FindControlRepository
    ) {
        super();
    }

    // Open the view option modal
    public openModal(patientId: string): void {
        this.setPatientId(patientId);
        this.uiFilterRepository.getUserOptionsFilter()
            .subscribe((filterConfig) => {
                this.defaultFilterOptionId = filterConfig.RPNOptionsUid;
                const preselectedItems: IColumnPk[] = [
                    {
                        Pk: this.defaultFilterOptionId
                    }
                ];
                this.ListRPNOptionModal(preselectedItems);
            });
    }


    public ListRPNOptionModal(selectedItems: IColumnPk[]) {
        this.apFindControlModalService.openModal(
            this.elementInjector,
            'ListRPNOptions',
            selectedItems,
            'sidenav',
            'Find RPN Viewing Options',
            FindControlMode.SingleSelect,
            undefined,
            undefined,
            undefined
        ).subscribe({
            next: (result: ApModalResultSuccess<any>) => {
                const selectedViewOptionData: ViewOptionDto = result?.resultValue?.[0] ?? null;
                if (selectedViewOptionData) {
                    this.loadSelectedViewOption(selectedViewOptionData.RPNOptionsUid);
                    this.updateMruMfuRpnList(selectedViewOptionData.RPNOptionsUid);
                }
            },
            error: () => {
                console.error('listRPNOption failed to open');
            }
        });
    }


    public applyDefaultFilterOption(filterData: ViewOptionDto) {
        this.uiFilterRepository.updateUserOptionsFilter(filterData.RPNOptionsUid)
            .pipe(
                takeUntil(this.onDestroy$)
            ).subscribe(
                (options: ViewOptionResponse) => {
                    if (options.RPNOptionsUid) {
                        this.patientNavService.notifyMenuRefresh(
                            {
                                context: PatientTabContext.ReviewPastNotes,
                                patientId: this.patientId,
                                isGlassBroken: false
                            }
                        );
                        const categoryId = this.patientNavService.getInitialCategoryId(filterData.RPNInitialCategory);
                        this.patientNavService.patientViewOptionSubject.next({
                            updatedContext: {
                              context: PatientTabContext.ReviewPastNotes,
                              patientId: this.patientId,
                              isGlassBroken: false
                            },
                            patientMenuId: categoryId
                          });
                    }
                },
            );
    }

    public loadSelectedViewOption(optionId: string): void {
        this.uiFilterRepository.getSelectedOptionsFilterConfig(optionId)
            .pipe(
                takeUntil(this.onDestroy$)
            ).subscribe(
                (data: ViewOptionDto) => this.applyDefaultFilterOption(data),
            );
    }


    public openViewOptionModal(
        selectedViewOptionData: ViewOptionDto,
        mode: 'link' | 'findControl' = 'findControl',
        patientId: string
    ): Promise<ApModalResult<IColumnPk>> {
        this.setPatientId(patientId);
        const states = { selectedViewOptionData: selectedViewOptionData, mode: mode };
        const result = this.apModalService.showComponentModal(ViewOptionModalComponent, {
            panelClass: ['emds-modal-full', 'fp-modal'],
            disableClose: true,
            initialState: {
                ...states,
            }
        });
        return result;
    }

    get getPatientId(): string {
        return this.patientId;
    }

    private setPatientId(patientId: string): void {
        this.patientId = patientId;
    }

    private updateMruMfuRpnList(selectedPkId: string) {
          this.findControlRepo.updateMfuMruList('ListRPNOptions' , [selectedPkId])
          .pipe(takeUntil(this.onDestroy$))
          .subscribe();
      }
}
